import { useCallback, useEffect, useRef, useState } from 'react'
import Layout from '../../components/Layout'
import PurchasesStyle from '../Purchases/Purchases'
import { ClipLoader } from 'react-spinners'
import { formatNumberWithIntl } from '../../lib/FormatNumbersWithIntl'
import Button from '../../components/Button'
import { useSelector } from 'react-redux'
import moment from 'moment'
import EyeIcon2 from '../../assets/icons/EyeIcon2'
import api from '../../api'
import { get } from 'lodash'
import ViewAccountModal from '../../components/Modal/ViewAccountModal'
import { BG_COLOR } from '../../constants/colors'

export default function InfoAboutCash() {
	const { getMe } = useSelector((state) => state.main)
	const viewAccountModalRef = useRef()
	const [cashPointCode, setCashPointCode] = useState('')
	const [cardMoneyCode, setCardMoneyCode] = useState('')

	const [cashPointMoney, setCashPointMoney] = useState([])
	const [isCashPointCashLoading, setIsCashPointCashLoading] = useState({
		loadingDebitCredit: false,
		balanceLoading: false,
	})

	const [cardMoney, setCardMoney] = useState([])
	const [isCardMoneyLoading, setIsCardMoneyLoading] = useState({
		loadingDebitCredit: false,
		balanceLoading: false,
	})

	const GetCardCash = useCallback(async () => {
		setIsCashPointCashLoading((prev) => ({
			...prev,
			balanceLoading: true,
		}))
		const conditions = [
			getMe?.U_CardAccount !== null ? `Code eq '${getMe.U_CardAccount}'` : '',
			getMe?.U_CashAccount !== null ? `Code eq '${getMe.U_CashAccount}'` : '',
			getMe?.U_CashUzsAccount !== null
				? `Code eq '${getMe.U_CashUzsAccount}'`
				: '',
			getMe?.U_TerminalAccount !== null
				? `Code eq '${getMe.U_TerminalAccount}'`
				: '',
			getMe?.U_TransAccount !== null ? `Code eq '${getMe.U_TransAccount}'` : '',
		].filter(Boolean)

		const filterCondition = conditions.length ? conditions.join(' or ') : ''
		const data = await api
			.get(
				`ChartOfAccounts?$filter=${
					filterCondition && get(getMe, 'Department2.Name', '') !== 'Boshqaruv'
						? filterCondition
						: `startswith(Code, '50') and ${
								getMe.Department2.Name === 'Boshqaruv' ||
								getMe.Department2.Name === 'GlavniyKassir'
									? 'ExternalCode ne null'
									: `contains(ExternalCode, '${getMe.U_AccountCode}')`
							}`
				}&$select=Code,Name,Balance,Balance_syscurr,Balance_FrgnCurr,AcctCurrency`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => JSON.parse(res.data).value)
		setCashPointMoney(data)
		setIsCashPointCashLoading((prev) => ({
			...prev,
			balanceLoading: false,
		}))
	}, [getMe])

	const GetCardMoney = useCallback(async () => {
		setIsCardMoneyLoading((prev) => ({
			...prev,
			balanceLoading: true,
		}))
		const conditions = [
			getMe?.U_CardAccount !== null ? `Code eq '${getMe.U_CardAccount}'` : '',
			getMe?.U_CashAccount !== null ? `Code eq '${getMe.U_CashAccount}'` : '',
			getMe?.U_CashUzsAccount !== null
				? `Code eq '${getMe.U_CashUzsAccount}'`
				: '',
			getMe?.U_TerminalAccount !== null
				? `Code eq '${getMe.U_TerminalAccount}'`
				: '',
			getMe?.U_TransAccount !== null ? `Code eq '${getMe.U_TransAccount}'` : '',
		].filter(Boolean)

		const filterCondition = conditions.length ? conditions.join(' or ') : ''
		const data = await api
			.get(
				`ChartOfAccounts?$filter=${
					filterCondition && get(getMe, 'Department2.Name', '') !== 'Boshqaruv'
						? filterCondition
						: `startswith(Code, '57') and ${
								getMe.Department2.Name === 'Boshqaruv' ||
								getMe.Department2.Name === 'GlavniyKassir'
									? 'ExternalCode ne null'
									: `contains(ExternalCode, '${getMe.U_AccountCode}')`
							}`
				}&$select=Code,Name,Balance,Balance_syscurr,Balance_FrgnCurr,AcctCurrency`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => JSON.parse(res.data).value)
		setCardMoney(data)
		setIsCardMoneyLoading((prev) => ({
			...prev,
			balanceLoading: false,
		}))
	}, [getMe])

	useEffect(() => {
		GetCardCash()
		GetCardMoney()
	}, [GetCardCash, GetCardMoney])

	return (
		<Layout>
			<PurchasesStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container mr-2">
					<p className="productTitle">Касса наличный</p>
					<label
						className={
							'font-medium text-zinc-600 text-[14px] mb-1 flex gap-2 flex-col my-2'
						}
					>
						Код касса наличный
						<input
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-48'}
							value={cashPointCode}
							onChange={(event) => setCashPointCode(event.target.value)}
						/>
					</label>
					{isCashPointCashLoading.loadingDebitCredit ||
					isCashPointCashLoading.balanceLoading ? (
						<ClipLoader
							loading={true}
							size={20}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<div>
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50  sticky top-0">
									<th scope="col" className="px-6 py-4">
										Счет
									</th>
									<th scope="col" className="px-6 py-4">
										Название
									</th>
									<th scope="col" className="px-6 py-4">
										Баланс
									</th>
									<th scope="col" className="px-6 py-4">
										Валюта
									</th>
									<th scope="col" className="px-6 py-4">
										Действие
									</th>
								</thead>
								<tbody>
									{cashPointMoney.length ? (
										cashPointMoney.map((v, i) => {
											return (
												v.Code.includes(cashPointCode) && (
													<tr
														className="bg-white border-b  hover:bg-gray-50 "
														key={i}
													>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.Code}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.Name}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.AcctCurrency === 'UZS'
																? formatNumberWithIntl(v.Balance_FrgnCurr)
																: formatNumberWithIntl(v.Balance)}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.AcctCurrency}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900">
															<Button
																onClick={() => {
																	viewAccountModalRef.current?.open({
																		startDate: moment().format('YYYY-MM-DD'),
																		endDate: moment().format('YYYY-MM-DD'),
																		accCode: v.Code,
																		accName: v.Name,
																	})
																}}
																className="!w-8 !h-10"
															>
																<EyeIcon2 />
															</Button>
														</td>
													</tr>
												)
											)
										})
									) : (
										<p className="px-6 py-4 font-medium text-gray-900 ">
											Счет нету
										</p>
									)}
								</tbody>
							</table>
						</div>
					)}
				</div>
				<div className="container ml-2">
					<p className="productTitle">Касса карта</p>
					<label
						className={
							'font-medium text-zinc-600 text-[14px] mb-1 flex gap-2 flex-col my-2'
						}
					>
						Код касса карта
						<input
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-48'}
							value={cardMoneyCode}
							onChange={(event) => setCardMoneyCode(event.target.value)}
						/>
					</label>
					{isCardMoneyLoading.loadingDebitCredit ||
					isCardMoneyLoading.balanceLoading ? (
						<ClipLoader
							loading={true}
							size={20}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<div>
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50  sticky top-0">
									<th scope="col" className="px-6 py-4">
										Счет
									</th>
									<th scope="col" className="px-6 py-4">
										Название
									</th>
									<th scope="col" className="px-6 py-4">
										Баланс
									</th>
									<th scope="col" className="px-6 py-4">
										Валюта
									</th>
									<th scope="col" className="px-6 py-4">
										Действие
									</th>
								</thead>
								<tbody>
									{cardMoney.length ? (
										cardMoney.map((v, i) => {
											return (
												v.Code.includes(cardMoneyCode) && (
													<tr
														className="bg-white border-b  hover:bg-gray-50 "
														key={i}
													>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.Code}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.Name}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.AcctCurrency === 'UZS'
																? formatNumberWithIntl(v.Balance_FrgnCurr)
																: formatNumberWithIntl(v.Balance)}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{v.AcctCurrency}
														</td>
														<td className="px-6 py-4 font-medium text-gray-900">
															<Button
																onClick={() => {
																	viewAccountModalRef.current?.open({
																		startDate: moment().format('YYYY-MM-DD'),
																		endDate: moment().format('YYYY-MM-DD'),
																		accCode: v.Code,
																		accName: v.Name,
																	})
																}}
																className="!w-8 !h-10"
															>
																<EyeIcon2 />
															</Button>
														</td>
													</tr>
												)
											)
										})
									) : (
										<p className="px-6 py-4 font-medium text-gray-900 ">
											Счет нету
										</p>
									)}
								</tbody>
							</table>
						</div>
					)}
				</div>
			</PurchasesStyle>
			<>
				<ViewAccountModal
					getRef={(r) => {
						viewAccountModalRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}
